// extracted by mini-css-extract-plugin
export default {"page":"Payment_page__pg6O-","icon":"Payment_icon__05YIc"};